import { enqueueSnackbar } from 'notistack';

import { SSR_MODE } from '@/lib/const';
import { getFriendlyPaymentName } from '@/lib/order';
import type { PaymentType } from '@/lib/payment/types';

export const openSimulation = async (
  url: string,
  width: number,
  height: number,
  type: PaymentType,
) => {
  if (SSR_MODE) {
    return;
  }
  const target = `${type}Simulation`;

  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  const newWindow = window.open(
    url,
    target,
    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,status=no`,
  );

  if (!newWindow) {
    enqueueSnackbar(
      `Please allow pop-ups for this website to open the ${getFriendlyPaymentName(
        '',
        type,
      )} financing simulation window.`,
      {
        variant: 'error',
      },
    );
  }
};
